module.exports = __webpack_public_path__ + "static/media/eyehide-primary.c28e3593.svg";